export default __webpack_public_path__ + "static/top-08044e27a28faa97fcc80297696f4d29.png";